export default __webpack_public_path__ + "static/media/HeroBanner_Image.5a326b24.png";